// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_e5676e49","menu":"_bdaef8e9","ctaWrapper":"_82a79e9f","ctaContent":"_739df4c5","ctaText":"_4a142f11","arrow":"_d957cdc3","fadeIn":"_991f2a5b","fadeOut":"_20d1d32"};